import * as React from 'react';

import styles from './styles.module.scss';

const PrivacyPolicyCompliance: React.FC = () => {

	return (
		<span>I have read and agree to
			<a className={styles.privacyPolicyLink} href="https://www.acceligent.com/privacy" rel="noopener noreferrer" target="_blank"> Acceligent&nbsp;privacy&nbsp;policy</a>&nbsp;*
		</span>
	);
};

export default React.memo(PrivacyPolicyCompliance);
